{
  "version": 1,
  "asset_id": "a64d3bea-642c-4cb1-b6ab-1d19dccf1e64",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/a64d3bea-642c-4cb1-b6ab-1d19dccf1e64/bypass-revision-oversized-pouch-es.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/a64d3bea-642c-4cb1-b6ab-1d19dccf1e64/bypass-revision-oversized-pouch-es.webp",
  "original_filename": "bypass-revision-oversized-pouch-es.webp",
  "size": 189748,
  "content_type": "image/webp",
  "created_at": "2026-10-05T22:37:14Z"
}
